module.exports = __webpack_public_path__ + "static/media/march2025-5.50158d51.webp";